import React from "react";
import { Badge } from "@shopify/polaris";

export const getIntentTone = (intent: string): "success" | "attention" | "info" | "critical" | "warning" | undefined => {
  switch (intent) {
    case 'FINANCIAL': return 'success';
    case 'QUALITY_DAMAGE': return 'critical';
    case 'FLAVOR_PREFERENCE': return 'attention';
    case 'OVERSTOCK': return 'info';

    case 'MALICIOUS': return 'critical';
    case 'SIZE_FIT': return 'info';
    case 'UNKNOWN': return 'warning';
    default: return undefined;
  }
};

const humanize = (text: string): string => {
  if (!text) return "";
  return text
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const formatIntentText = (intent: string): string => {
  if (!intent) return "PENDING";
  if (intent === 'MALICIOUS') return 'FRAUD';
  return humanize(intent);
};

export const formatActionText = (action: string): string => {
  if (!action) return "Process";
  if (action === 'REFUND_ONLY') return 'Refund Only';
  if (action === 'PAUSE_AND_SAVE') return 'Pause & Save';
  if (action === 'PAUSE_AND_REPLACE') return 'Pause & Replace';
  return humanize(action);
};

export const getTicketStatusBadge = (status: string) => {
  switch (status) {
    case "OPEN": return <Badge tone="info" size="small">Sent</Badge>;
    case "SENT": return <Badge tone="info" size="small">Sent</Badge>;
    case "RECEIVED": return <Badge tone="attention" size="small">Received</Badge>;
    case "IN_PROGRESS": return <Badge tone="info" size="small">In Progress</Badge>;
    case "RESOLVED": return <Badge tone="success" size="small">Resolved</Badge>;
    default: return <Badge size="small">Sent</Badge>;
  }
};

export const formatCurrency = (amount: number, currencyCode: string = "USD", locale: string = "en-US"): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
  }).format(amount);
};
